import User from './User.js'
import {formatTime} from '../../../date.js'
import {FormattedRealDate} from '../../FormattedDate.js'

export default function Comment({comment: {date, text, user}}) {
  return (
    <dl className="list--order-data list--timeline-point">
      <dt className="list__item--order-data list__title--timeline-point">
        <FormattedRealDate value={date} format={formatTime} />
      </dt>
      <dd className="list__item--order-data list__item--timeline-point">
        <div className="message--timeline-point">{text}</div>
        {user && <User email={user} />}
      </dd>
    </dl>
  )
}
